// extracted by mini-css-extract-plugin
export default {"Grid":"Review_Grid__xySOf"};